<template>
  <div 
    @click="$emit('click')"
    class="relative bg-gradient-to-b from-[var(--gray-stack-2)] to-[var(--gray-stack-1)] border border-[rgba(0,0,0,.18)] dark:border-white/10 rounded-token-lg shadow-[inset_0_1px_0_rgba(255,255,255,.92),inset_0_-1px_0_rgba(0,0,0,.22),inset_0_-2px_2px_rgba(0,0,0,.12)] dark:shadow-[inset_0_1px_0_rgba(255,255,255,.08),inset_0_-1px_0_rgba(0,0,0,.50),inset_0_-2px_2px_rgba(0,0,0,.60)] before:pointer-events-none before:absolute before:inset-0 before:rounded-[inherit] before:shadow-[inset_0_1px_0_rgba(255,255,255,.95)] dark:before:shadow-[inset_0_1px_0_rgba(255,255,255,.10)] p-6 hover:shadow-3d transition-all duration-200 cursor-pointer h-full flex flex-col group"
  >
    <div class="flex-1 flex flex-col items-center justify-center text-center">
      <div class="flex-shrink-0 mb-4">
        <component 
          v-if="typeof integration.icon === 'function'"
          :is="integration.icon" 
          class="h-16 w-16 bg-white rounded-token-sm p-1"
          :class="integration.connected ? 'text-green-500' : 'text-gray-400 dark:text-gray-500'"
        />
        <img 
          v-else-if="!iconError"
          :src="integration.icon" 
          :alt="`${integration.name} icon`"
          class="h-16 w-16 bg-white rounded-token-sm p-1 object-contain"
          :class="integration.connected ? 'opacity-100' : 'opacity-50'"
          @error="iconError = true"
        />
        <div
          v-else
          class="h-16 w-16 bg-white rounded-token-sm p-1 flex items-center justify-center text-xl font-semibold text-gray-500 dark:text-gray-400"
        >
          {{ (integration.name || '?').charAt(0) }}
        </div>
      </div>
      <div class="flex-1">
        <h3 class="text-lg font-medium text-gray-900 dark:text-gray-50 mb-2">{{ integration.name }}</h3>
        <p class="text-sm text-gray-600 dark:text-gray-300 mb-4">{{ integration.description }}</p>
      </div>
      <div class="flex-shrink-0">
        <span 
          v-if="integration.connected" 
          class="inline-flex items-center px-3 py-1 rounded-token-sm text-sm font-medium bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200 border border-green-200 dark:border-green-700"
        >
          Connected
        </span>
        <span 
          v-else-if="integration.comingSoon" 
          class="inline-flex items-center px-3 py-1 rounded-token-sm text-sm font-medium bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200 border border-yellow-200 dark:border-yellow-700"
        >
          Coming Soon
        </span>
        <span 
          v-else 
          class="inline-flex items-center px-3 py-1 rounded-token-sm text-sm font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 border border-gray-200 dark:border-gray-600"
        >
          Not Connected
        </span>
      </div>
    </div>
    
    <!-- Hover indicator -->
    <div class="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400 dark:text-gray-500" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414 1.414l4-4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  integration: {
    type: Object,
    required: true
  }
});

defineEmits(['click']);

// When icon image fails to load (e.g. missing or corrupt asset), show letter fallback
const iconError = ref(false);
</script> 